import TotalSumWidget from "./TotalSumWidget";

export default TotalSumWidget;